<template>
  <div class="popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="popup-content bg-white w-1/3 py-5 relative rounded-lg shadow-lg">
      <div class="flex font-c7 text-c24 px-5">
        {{ isActive ? 'Désactiver' : 'Activer' }} l'administrateur
      </div>

      <div class="mt-10 text-center">
        <icon
          :data="isActive ? icons.ic_desactivate : icons.active"
          height="100"
          width="100"
          class="mx-auto"
          original
        />

        <div class="w-3/5 mx-auto mt-5">
          <p class="text-gray-600 mb-2">
            Êtes-vous sûr de vouloir
            <strong>{{ isActive ? 'désactiver' : 'activer' }}</strong>
            cet administrateur ?
          </p>
          <p class="font-semibold text-gray-800">
            {{ item.person.firstName }} {{ item.person.lastName }}
          </p>
        </div>
      </div>

      <div class="mt-5">
        <div class="flex justify-end items-center mt-5 mx-5 gap-3">
          <button
            class="font-c5 text-gray-600 px-7 py-3 rounded-8 border border-gray-300 hover:bg-gray-50"
            @click="$emit('close')"
          >
            Annuler
          </button>

          <button
            :style="{ backgroundColor: isActive ? '#ef4444' : '#22c55e' }"
            class="text-white px-7 py-3 rounded-8 font-c6"
            @click="confirm"
          >
            {{ isActive ? 'Désactiver' : 'Activer' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ic_desactivate from "@/assets/icons/ic-desactivate.svg"
import active from "@/assets/icons/active.svg"

export default {
  name: 'ToggleStatusPopup',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  emits: ['close', 'confirm'],

  data() {
    return {
      icons: {
        ic_desactivate,
        active
      }
    }
  },

  computed: {
    isActive() {
      return this.item?.person?.status === 'ACTIVE'
    }
  },

  methods: {
    confirm() {
      this.$emit('confirm', {
        item: this.item,
        isActive: this.isActive
      })
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  min-height: 25rem;
}
</style>
